import { Grid } from "@mui/material";

import { QuickLink } from "app/frontend/components/static/incentives/QuickLink";
import { EProjectTypes } from "app/frontend/constants/enums";
import { QUICK_LINKS } from "app/frontend/constants/static_content";
import { useCurrentProjectType } from "app/frontend/hooks/project/useCurrentProjectType";

const BottomQuickLinks = () => {
    const projectType = useCurrentProjectType();

    return QUICK_LINKS.filter(
        (link) => link.projects.includes(EProjectTypes.ALL) || link.projects.includes(projectType),
    ).map((link) => {
        return (
            <Grid key={link.header} size={{ xs: 12, lg: 12 / QUICK_LINKS.length }}>
                <QuickLink link={link} />
            </Grid>
        );
    });
};

export default BottomQuickLinks;
